import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConditionComponentInformation } from 'app/models/monitor/condition-component-information.model';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { ConditionComponentGQL } from '../../graphql';

@Injectable()
export class ConditionComponentInfoService {

  constructor(
    private conditionComponentGQL: ConditionComponentGQL
  ) { }

  public getConditionComponentData(turbineSerialObservable: Observable<number>): Observable<ConditionComponentInformation[]> {
    return turbineSerialObservable.pipe(
      distinctUntilChanged(),
      switchMap((turbineSerial: number) =>
        this.conditionComponentGQL.subscribe({
          variables: {
            serialNav: turbineSerial
          }
        }).pipe(
          map(result => ConditionComponentInformation.mapFromTurbines(result.data.turbines[0].parkSubType.turbines, turbineSerial))
        )
      )
    );
  }

}
